import { create } from "zustand";
import { persist } from "zustand/middleware";

interface CartItem {
  id: string;
  name: string;
  price: number;
  qty: number;
  images?: string[];
}

interface CartState {
  items: CartItem[];
  addToCart: (item: CartItem) => void;
  removeFromCart: (id: string) => void;
  onItemAdded?: () => void;
  setOnItemAdded: (callback: () => void) => void;
}

export const useCartStore = create<CartState>()(
  persist(
    (set, get) => ({
      items: [],
      onItemAdded: undefined,
      addToCart: (item: CartItem) => {
        set((state: CartState) => {
          const existing = state.items.find((i: CartItem) => i.id === item.id);
          if (existing) {
            return {
              items: state.items.map((i: CartItem) =>
                i.id === item.id ? { ...i, qty: i.qty + item.qty } : i
              ),
            };
          }
          return { items: [...state.items, item] };
        });
        // Call the callback if it exists
        const currentState = get();
        if (currentState.onItemAdded) {
          currentState.onItemAdded();
        }
      },
      removeFromCart: (id: string) => {
        set((state: CartState) => ({
          items: state.items.filter((i: CartItem) => i.id !== id),
        }));
      },
      setOnItemAdded: (callback: () => void) => {
        set({ onItemAdded: callback });
      },
    }),
    {
      name: "cart-storage",
    }
  )
);

// Keep the original store for cartOpen if needed
interface StoreState {
  cartOpen: boolean;
  setCartOpen: (open: boolean) => void;
}

export const useStore = create<StoreState>((set) => ({
  cartOpen: false,
  setCartOpen: (open: boolean) =>
    set((state) => ({ ...state, cartOpen: open })),
}));
